import { FC } from 'react'
import { Box, Typography, Dialog, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'

const mobileScreenWidth = '767px'

const StyledBody = styled(Box)(({ theme }) => ({
    backgroundColor: '#EEF0F4',
    padding: '2.4rem 4rem',
    '&:focus': {
        outline: 'none',
    },
    [`@media (max-width:${mobileScreenWidth})`]: {
        //padding: disablePadding ? 0 : '24px 16px',
    },
}))

const StyledModalHeader = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '12%',
    padding: '2.8rem 1.2rem 1.6rem 2.8rem',
    backgroundColor: '#ffffff',
})

const StyledCloseIcon = styled(Box)({
    display: 'flex',
    height: '1.3rem',
    marginTop: '-1.3rem',
})

const StyledTitle = styled(Typography)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#3b454d',
})

const StyledFooter = styled(Box)({
    backgroundColor: '#ffffff',
})

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        borderRadius: 10,
        maxWidth: '80rem',
        [`@media (max-width:${mobileScreenWidth})`]: {
            margin: '0.8rem',
            width: 'calc(100% - 1.6rem) !important',
            maxWidth: 'calc(100% - 1.6rem) !important',
        },
    },
})

export interface ModalProps {
    open?: any
    onClose?: any
    title?: any
    footerContent?: any
    headerContent?: any
    children?: React.ReactNode
}

export const Modal: FC<ModalProps> = (props) => {
    const { open, onClose, title, children, headerContent, footerContent } =
        props

    return (
        <StyledDialog
            scroll={'body'}
            open={open}
            onClose={onClose}
            aria-labelledby={title}
            aria-describedby={title}
        >
            <StyledModalHeader>
                {!headerContent ? (
                    <StyledTitle>{title}</StyledTitle>
                ) : (
                    headerContent
                )}

                <StyledCloseIcon>
                    <IconButton onClick={onClose} size="large">
                        <Icon
                            style={{ height: 13, width: 13 }}
                            name="Close"
                            color="#727272"
                        />
                    </IconButton>
                </StyledCloseIcon>
            </StyledModalHeader>

            <StyledBody>{children}</StyledBody>

            <StyledFooter>{footerContent}</StyledFooter>
        </StyledDialog>
    )
}
